import { render } from "./SucessoPage.vue?vue&type=template&id=7571c0e5&scoped=true"
import script from "./SucessoPage.vue?vue&type=script&lang=js"
export * from "./SucessoPage.vue?vue&type=script&lang=js"

import "./SucessoPage.vue?vue&type=style&index=0&id=7571c0e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7571c0e5"]])

export default __exports__